import { FunctionComponent } from 'react'

const MobiHeaderUnderline: FunctionComponent = () => {
  return <div className='h-1 md:h-2 w-24 my-4 bg-gradient-to-r from-[#c81e37] to-[#eb0014]' />
}
export default MobiHeaderUnderline
